import EnvironmentSettings from "../../Classes/Models/EnvironmentSettings";
import UsersApi from "./UsersApi";
import TenantManager from "./TenantManager";

class PartitionApi {
  constructor() {
    this.baseUrl =
      EnvironmentSettings.Environment === "dev"
        ? EnvironmentSettings.LocalUrl
        : EnvironmentSettings.LiveUrl;
  }

  //============================= URls ============================//
  PartitionUrl = "Partition/";

  //============================= Private Helper ============================//
  async getHeaders() {
    const token = await UsersApi.GetToken();
    return {
      Authorization: `Bearer ${token}`,
      tenant: TenantManager.getTenant(token),
      "Content-Type": "application/json",
    };
  }

  //============================= Bundles Methods ============================//

  async CreatePartition(payload) {
    const res = await fetch(this.baseUrl + this.PartitionUrl, {
      method: "POST",
      headers: await this.getHeaders(),
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    return data;
  }

  async GetPartitions(payload) {
    const res = await fetch(this.baseUrl + this.PartitionUrl + "GetAll", {
      method: "POST",
      headers: await this.getHeaders(),
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    return data;
  }

  async UpdatePartition(id, payload) {
    const res = await fetch(this.baseUrl + this.PartitionUrl + id, {
      method: "PUT",
      headers: await this.getHeaders(),
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    return data;
  }
}

export default new PartitionApi();
